export function TermsAndConditionsCheckbox({ forId }: { forId: string }) {
  return (
    <label htmlFor={forId} className="cursor-pointer">
      I hereby accept the terms of this{' '}
      <a
        href="/legal/gradle-software-evaluation-agreement/"
        className="underline-text-blue"
        target="_blank"
        onClick={e => e.stopPropagation()}
      >
        Gradle Software Evaluation Agreement
      </a>{' '}
      and{' '}
      <a href="/legal/privacy/" className="underline-text-blue" target="_blank" onClick={e => e.stopPropagation()}>
        Privacy Statement
      </a>
      .
    </label>
  );
}

export function TermsAndPrivacyCheckbox({ forId }: { forId: string }) {
  return (
    <label htmlFor={forId} className="cursor-pointer">
      By submitting this form, you agree to accept Gradle&apos;s{' '}
      <a href="/legal/terms-of-use/" className="underline-text-blue" target="_blank" onClick={e => e.stopPropagation()}>
        terms
      </a>{' '}
      and{' '}
      <a href="/legal/privacy/" className="underline-text-blue" target="_blank" onClick={e => e.stopPropagation()}>
        privacy policy
      </a>
      .
    </label>
  );
}
